/*
 * @Author: Dom
 * @Date: 2022-08-05 17:31:10
 * @LastEditTime: 2022-08-05 17:41:55
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\bank.ts
 */
export default [
    {id:1,name: '中国工商银行'},
    {id:2,name: '招商银行'},
    {id:3,name: '中国农业银行'},
    {id:4,name: '中国建设银行'},
    {id:5,name: '中国银行'},
    {id:6,name: '中国民生银行'},
    {id:7,name: '中国光大银行'},
    {id:8,name: '中信银行'},
    {id:9,name: '交通银行'},
    {id:10,name: '兴业银行'},
    {id:11,name: '上海浦东发展银行'},
    {id:12,name: '中国人民银行'},
    {id:13,name: '华夏银行'},
    {id:14,name: '深圳发展银行'},
    {id:15,name: '广东发展银行'},
    {id:16,name: '国家开发银行'},
    {id:17,name: '中国邮政储蓄银行'},
    {id:18,name: '中国进出口银行'},
    {id:19,name: '中国农业发展银行'},
    {id:20,name: '中国银行香港分行'},
    {id:21,name: '北京银行'},
    {id:22,name: '北京农村商业银行'},
    {id:23,name: '天津银行'},
    {id:24,name: '上海银行'},
    {id:25,name: '上海农村商业银行'},
    {id:26,name: '南京银行'},
    {id:27,name: '宁波银行'},
    {id:28,name: '杭州市商业银行'},
    {id:29,name: '深圳平安银行'},
    {id:30,name: '深圳农村商业银行'},
    {id:31,name: '温州银行'},
    {id:32,name: '厦门国际银行'},
    {id:33,name: '济南市商业银行'},
    {id:34,name: '重庆银行'},
    {id:35,name: '哈尔滨银行'},
    {id:36,name: '成都市商业银行'},
    {id:37,name: '包头市商业银行'},
    {id:38,name: '南昌市商业银行'},
    {id:39,name: '贵阳商业银行'},
    {id:40,name: '兰州市商业银行'},
    {id:41,name: '常熟农村商业银行'},
    {id:42,name: '青岛市商业银行'},
    {id:43,name: '徽商银行'},
    {id:44,name: '花旗中国银行'},
    {id:45,name: '汇丰中国银行'}
]
